import { FormGroup } from '@angular/forms';
import { Coach } from '@app/degreed-coach/models/coach.model';

export interface CoachBuilderState {
  coachId: string;
  knowledgeBaseId: string;
  selectedCoach: Coach | null;
  coaches: Coach[];
  filteredCoaches: Coach[];
  loading: boolean;
  searchTerm: string;
  selectedStatus: string[];
}

export enum CoachStatusEnum {
  Draft = 'Draft',
  Published = 'Published',
  Inactive = 'Inactive',
}

export enum CoachConversationMode {
  TextOnly = 'TextOnly',
  VoiceOnly = 'VoiceOnly',
  Both = 'Both',
}

export interface CoachBuilderViewModel extends CoachBuilderState {
  createOrUpdateCoach: (form: FormGroup) => void;
  getInitialForm: () => FormGroup;
  searchCoaches: (term: string) => void;
  filterByStatus: (status: string | null) => void;
  loadCoaches: () => Promise<void>;
  selectCoachForEdit: (coachId: number) => void;
  addPrompt: (coachId: number, prompt: string) => void;
  removePrompt: (coachId: number, promptId: string) => void;
  getSelectedCoach: () => Coach | null;
}

export interface CoachValidationErrors {
  isValid: boolean;
  invalidFields: {
    fieldName: string;
    reason: string;
  }[];
}
